import { render, staticRenderFns } from "./TypeManagent.vue?vue&type=template&id=5592f371"
import script from "./TypeManagent.vue?vue&type=script&lang=js"
export * from "./TypeManagent.vue?vue&type=script&lang=js"
import style0 from "./TypeManagent.vue?vue&type=style&index=0&id=5592f371&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports